module.exports = __webpack_public_path__ + "img/logo.b1dd75d5.svg";